<template>
  <el-container class="parent">
    <el-aside width="350px" class="containerside">
      <div style="margin-bottom:20px">
        <span class="title_before " style="padding-left:24px">通用设置</span>
      </div>
      <div class="side_min">
        <ul
          style="  max-height: 710px;
  overflow-y: auto;"
          class="user_list"
        >
          <li class="user_active">
            <div>
              <i
                class="iconfont icon-user addColor"
                style="font-size:20px;line-height: 36px"
              ></i>
              <span style="line-height: 36px;height:36px"
                >固定资产审批项管理</span
              >
            </div>
          </li>
        </ul>
      </div>
    </el-aside>
    <el-main class="min">
      <div style="margin-bottom:20px">
        <span class="title_before " style="padding-left:24px">设置项</span>
      </div>
      <div style="padding:0px 20px">
        <div>
          <ul class="firstul">
            <el-checkbox
              v-model="item.isAllow"
              @change="checkboxChange(item)"
              v-for="item in checkboxArr"
              :key="item.model"
              >{{ item.allowName }}</el-checkbox
            >
          </ul>
        </div>
      </div>
    </el-main>
  </el-container>
</template>
<script>
export default {
  data() {
    return {
      checkboxArr: [],
    };
  },
  mounted() {},
  methods: {
    checkboxChange(data) {
      this.$requestAxios(
        {
          url: "/pc/eswitch/start",
          data: { type: data.allowType, start: data.isAllow },
        },
        (data) => {
          // this.$success();
          this.init();
        }
      );
    },
    init() {
      this.$requestAxios(
        {
          url: "/pc/eswitch/list",
          data: {},
        },
        (data) => {
          this.checkboxArr = data.data;
        }
      );
    },
  },
};
</script>
<style scoped>
ul,
li {
  padding: 0;
  margin: 0;
}
.firstul {
}
.firstul > li {
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 43px;
  padding-top: 55px;
}
.firstul > li:first-child {
  padding-top: 20px;
}
.min_foo {
  position: fixed;
  bottom: 22px;
  right: 40px;
  width: 100%;
}
.min_foo > div {
  height: 80px;
}
.childrenul {
  display: flex;
  flex-flow: row wrap;
  margin-left: 28px;
}
.childrenul > li {
  margin-right: 40px;
  margin-top: 20px;
}
.parent {
  height: 100%;
  background-color: #f6f7fc;
}

.side_min {
  padding-left: 20px;
  margin-top: 20px;
  height: 100%;
}
.input_icon {
  margin-bottom: 30px;
}

.user_list,
.user_list li {
  margin: 0;
  padding: 0;
}
.user_list li {
  padding-left: 22px;
  padding-right: 10px;
  background-color: #fff;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
}
.user_list li > div:last-child {
  display: none;
}
.user_list li > div:first-child > span {
  font-size: 14px;
  line-height: 24px;
  margin-left: 10px;
  color: #333333;
  line-height: 36px;
}
.user_list li:hover {
  background-color: #f3f6fb;
  border-radius: 2px;
}
.user_list li > div:last-child > i:last-child {
  margin-left: 10px;
  opacity: 0.8;
}

.user_list li:hover > div:last-child {
  display: block;
}

.user_active {
  background-color: #f3f6fb !important;
  border-radius: 2px;
}
.user_active > div:last-child {
  display: block !important;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
}
.iconList > i {
  padding-right: 10px;
}
.working {
  background-color: #d8e6ff;
  border-radius: 4px;
  width: 40px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  display: inline-block;
  font-size: 12px;
  letter-spacing: 0px;
  color: #7c7c7c;
}
.dimission {
  background-color: #e0e0e0;
  border-radius: 4px;
  width: 40px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  display: inline-block;
  font-size: 12px;
  letter-spacing: 0px;
  color: #7c7c7c;
}
</style>
